
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    summary: {
      type: String,
      required: true
    },
    image: {
      type: String,
      required: true
    },
    imageAlt: {
      type: String,
      required: true
    },
    date: {
      type: String,
      required: true
    },
    formattedDate: {
      type: String,
      required: true
    },
    author: {
      type: String,
      required: true
    },
    readTime: {
      type: Number,
      default: null
    }
  }
}
